import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';
import './agenda.css';
import { agenda } from '../../json/agenda';

const Agenda = () => {
    const [events, setEvents] = useState([]);
    const [modalStatus, setModalStatus] = useState(false);
    const [eventData, setEventData] = useState([]);

    useEffect(() => {
        setEvents(agenda);
        window.scrollTo(0, 0);
    }, []);


    const handleEventClick = (eventClickInfo) => {
        // Obtener información del evento
        setModalStatus(true);
        const eventTitle = eventClickInfo.event.title;
        const eventPlace = eventClickInfo.event.extendedProps.place;
        const eventDescription = eventClickInfo.event.extendedProps.description;
        
        setEventData([eventTitle, eventPlace, eventDescription]);
    };

    const calendarOptions = {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        events: events,
        eventClick: handleEventClick // Agregar manejador de eventos
    };

    return (
        <>
            <div id='calendar'>
                <div className='container'>
                    <div className='row'>
                        <div>
                            <h3 className='title'>Agenda de la Secretaria</h3>
                            <hr className='hr-gob'/>
                        </div>
                        {
                            modalStatus && (
                                <div id='modal-agenda'>
                                    <div className='close-icon' onClick={() => setModalStatus(false)}>
                                        {/* SVG para el ícono de cerrar */}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="close-svg"
                                        >
                                            <line x1="18" y1="6" x2="6" y2="18" />
                                            <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                    </div>
                                    <p className='agenda-title'>{eventData[0]}</p>
                                    <p className='agenda-location'>
                                        <i className="fa-solid fa-location-dot"></i> {eventData[1]}
                                    </p>
                                    <iframe
                                        id="url"
                                        src={eventData[2]}
                                        className='twitter-embed'
                                        frameBorder="0"
                                        scrolling="auto"
                                        allowTransparency="true"
                                        allow="encrypted-media"
                                    ></iframe>
                                </div>
                            )
                        }
                        <div className='container'>
                            <div className="agenda">
                                <FullCalendar {...calendarOptions} locale={esLocale}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    )
}

export default Agenda;
